import Settings from 'src/Settings';
import RedesignDescriptor from './app-tour-redesign';
import RefiveDescriptor from './app-tour-refive';
import CanteenDescriptor from './app-tour-canteen';
import CompanyKitchenDescriptor from './app-tour-companykitchen';
import BuildTypes from 'src/constants/BuildTypeConstants';

const typeDescriber = {
  [BuildTypes.default]: RedesignDescriptor,
  [BuildTypes.refive]: RefiveDescriptor,
  [BuildTypes.canteen]: CanteenDescriptor,
  [BuildTypes.companykitchen]: CompanyKitchenDescriptor,
};

export function getAppTourDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
